import { Alert, AlertKind, DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useExtractContext } from "@/pages/import/DatasetsPage/ExtractPage";

const formatCount = (value: number | null | undefined) => value?.toLocaleString() ?? "—";

const ExtractDetails = () => {
  const { extract } = useExtractContext();
  const errored = extract.records_errored ?? 0;

  return (
    <div className="space-y-8">
      {extract.error && <Alert kind={AlertKind.ERROR}>{extract.error.message}</Alert>}

      <div>
        <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
        <div className="mt-4">
          <DescriptionList>
            <DescriptionList.Item label="ID" value={extract.id} />
            <DescriptionList.Item label="Dataset ID" value={extract.dataset_id} />
            <DescriptionList.Item label="Submitted" value={<Timestamp timestamp={extract.submitted_at} />} />
            <DescriptionList.Item
              label="Started"
              value={extract.started_at ? <Timestamp timestamp={extract.started_at} /> : "—"}
            />
            <DescriptionList.Item
              label="Ended"
              value={extract.ended_at ? <Timestamp timestamp={extract.ended_at} /> : "—"}
            />
          </DescriptionList>
        </div>
      </div>

      <div>
        <h3 className="text-lg/6 font-medium text-gray-900">Summary</h3>
        <div className="mt-4">
          <DescriptionList>
            <DescriptionList.Item label="Processed" value={formatCount(extract.records_processed)} />
            <DescriptionList.Item label="New" value={formatCount(extract.records_new_inserted)} />
            <DescriptionList.Item label="Updated" value={formatCount(extract.records_existing_updated)} />
            <DescriptionList.Item label="Unchanged" value={formatCount(extract.records_existing_unchanged)} />
            <DescriptionList.Item label="Deleted" value={formatCount(extract.records_existing_deleted)} />
            <DescriptionList.Item
              label="Errored"
              value={<span className={errored > 0 ? "text-red-600" : undefined}>{formatCount(errored)}</span>}
            />
          </DescriptionList>
        </div>
      </div>
    </div>
  );
};

export default ExtractDetails;
